import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { KeyRound, MailCheck } from "lucide-react";
import api from "../lib/api";

const ForgotPasswordModal = ({ open, onClose }) => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setSent(true); // avoid enumeration; always show success
    } finally { setBusy(false); }
  };

  const close = () => { setSent(false); setEmail(""); onClose(); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="sm:max-w-md rounded-2xl">
        {!sent ? (
          <>
            <DialogHeader>
              <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-50"><KeyRound className="h-6 w-6 text-indigo-700" /></div>
              <DialogTitle className="text-2xl font-bold text-[#1a1a2e]">Reset your password</DialogTitle>
              <DialogDescription className="text-slate-500">Enter your account email and we'll send you a secure reset link.</DialogDescription>
            </DialogHeader>
            <form onSubmit={submit} className="mt-2 space-y-3">
              <div className="space-y-1.5"><Label>Email</Label><Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@firm.co" className="rounded-xl" /></div>
              <Button type="submit" disabled={busy} className="w-full rounded-xl bg-[#2f2b8f] py-6 text-sm font-semibold text-white hover:bg-[#26236f]">
                {busy ? "Sending..." : "Send reset link"}
              </Button>
            </form>
          </>
        ) : (
          <div className="py-4 text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50"><MailCheck className="h-7 w-7 text-emerald-600" /></div>
            <h3 className="text-xl font-bold text-[#1a1a2e]">Check your inbox</h3>
            <p className="mt-2 text-sm text-slate-500">If an account exists for <span className="font-medium text-[#1a1a2e]">{email}</span>, a password reset link is on its way. The link is valid for 60 minutes.</p>
            <Button onClick={close} className="mt-6 w-full rounded-xl bg-[#2f2b8f] py-6 text-sm font-semibold text-white hover:bg-[#26236f]">Done</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ForgotPasswordModal;
